import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-0" }, "Gutschein", -1)
const _hoisted_3 = { class: "" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "checkout-input-voucher-order"
}, "Ich möchte diese Kurskarte als Gutschein kaufen.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-info-circle text-warningX me-1" }),
  /*#__PURE__*/_createTextVNode(" Dieses Produkt kann nicht als Gutschein gekauft werden. ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-exclamation-triangle text-warningX me-1" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Du bist nicht angemeldet und kannst Kurskarten daher nur als Gutschein kaufen. ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-info-circle text-warningX me-1" }),
  /*#__PURE__*/_createTextVNode(" Ein geschlossener Kurs kann nicht als Gutschein gekauft werden. ")
], -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "checkout-input-voucher-redeem"
}, "Ich möchte einen Gutscheincode für diese Bestellung einlösen.", -1)
const _hoisted_12 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_VoucherCheck = _resolveComponent("VoucherCheck")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "d-none form-check-input",
          id: "checkout-input-voucher-order",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.buyVoucher) = $event)),
          disabled: !_ctx.loggedIn || _ctx.product.type === 2 || !_ctx.product.voucherable
        }, null, 8, _hoisted_4), [
          [_vModelCheckbox, _ctx.buyVoucher]
        ]),
        _hoisted_5
      ]),
      (_ctx.product.type !== 2 && !_ctx.product.voucherable)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            type: "dark",
            small: "",
            class: "mt-2 mb-4"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : (!_ctx.loggedIn)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 1,
              type: "warning",
              class: "mt-2 mb-4"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            }))
          : (_ctx.product.type === 2)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 2,
                type: "dark",
                small: "",
                class: "mt-2 mb-4"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", null, null, 512), [
      [_vShow, _ctx.buyVoucher]
    ]),
    _createElementVNode("div", _hoisted_10, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        class: "d-none form-check-input",
        id: "checkout-input-voucher-redeem",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.redeemVoucher) = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.redeemVoucher]
      ]),
      _hoisted_11
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createVNode(_component_VoucherCheck, {
        context: "checkout",
        "region-id": _ctx.product.region_id,
        onValid: _ctx.onVoucherCodeValid,
        onReset: _ctx.onVoucherCodeReset
      }, null, 8, ["region-id", "onValid", "onReset"])
    ], 512), [
      [_vShow, _ctx.redeemVoucher]
    ])
  ]))
}